import React, {Component} from 'react';
import IntlProvider from 'toluna-frontend-components/IntlProvider';
import Localized from 'toluna-frontend-components/IntlProvider/Localized';
import {getTranslations} from '../utils';


export default (WrappedComponent, translationPath = '') => {
  return class WithTranslationsHOC extends Component {
    constructor(props){
      super(props);
      this.translations = getTranslations(translationPath);
    }
    render() {
      //let LocalizedComponent = Localized(WrappedComponent);

      //console.log(component);
      //console.log(localizedComponent);



      return(
        <WrappedComponent {...this.props} intl={{translations: this.translations}}/>
      );
    }
  }

};



// WEBPACK FOOTER //
// ./common/hocs/withTranslations.js